<template>
	<div>
		<h3>
			<IconLearning />
			{{ 'Learning' | translate }}
		</h3>
		<div class="list-group row">
			<div v-for="group in groups" :key="group.id" class="col-12">
				<div v-if="isActive(group.lessons)">
					<GroupName
						:onSelect="onSelect"
						type="completed"
						:length="group.lessons.length"
						:name="group.name"
						:order="group.order"
						:orientation="isSelected(group.order) ? 'top' : 'bottom'"
					/>
					<div v-if="isSelected(group.order)">
						<GroupLessons
							type="completed"
							:lessons="group.lessons"
							:length="group.lessons.length"
						/>
					</div>
				</div>
				<div v-else-if="isLock(group.lessons)">
					<GroupName
						:onSelect="onSelect"
						type="lock"
						:length="group.lessons.length"
						:name="group.name"
						:order="group.order"
						:orientation="isSelected(group.order) ? 'top' : 'bottom'"
					/>
				</div>
				<div v-else-if="isPlay(group.lessons)">
					<GroupName
						:onSelect="onSelect"
						type="pause"
						:length="group.lessons.length"
						:name="group.name"
						:order="group.order"
						:orientation="isSelected(group.order) ? 'top' : 'bottom'"
					/>
					<div v-if="isSelected(group.order)">
						<GroupLessons
							type="pause"
							:lessons="group.lessons"
							:length="group.lessons.length"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import IconLearning from '@/components/svg/IconLearning'
import GroupName from '@/components/DashboardStudent/Learning/GroupName'
import GroupLessons from '@/components/DashboardStudent/Learning/GroupLessons'

export default {
	name: 'Learning',
	components: {
		IconLearning,
		GroupName,
		GroupLessons,
	},
	props: {
		groups: {
			default: [],
		},
	},
	mounted() {},
	data: () => ({
		selected: [],
	}),
	methods: {
		isSelected(order) {
			return this.selected.some(el => el === order)
		},
		onSelect(order) {
			if (this.selected.some(el => el === order)) {
				this.selected = this.selected.filter(el => el !== order)
			} else {
				this.selected = [...this.selected, order]
			}
		},
		isActive(lessons) {
			return lessons.length > 0 && lessons.every(el => el.is_active)
		},
		isLock(lessons) {
			return lessons.length > 0 && lessons.every(el => !el.is_active)
		},
		isPlay(lessons) {
			return lessons.length > 0 && lessons.some(el => el.is_active)
		},
	},
}
</script>
